import React from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as JoyBuddy } from '../../../../../assets/icons/buddy-joy.svg';
import { BreadcrumbItemProps } from '../../../../../shared/components/Breadcrumbs/BreadcrumbItem/BreadcrumbItem';
import GenericPageNE from '../../../../../shared/components/GenericPageNE/GenericPageNE';
import { REWARDS_HISTORY_ROUTE, REWARDS_POINTS_ROUTE } from '../../../../../shared/constants/auth';
import { CLICK_ACTION, SEND_MORE_POINTS, GO_TO_ORDER_HISTORY } from '../../../../../shared/constants/tagManager';
import tagManagerService from '../../../../../shared/services/gtm/tagManagerService';
import { TRANSLATION_POINTS_CONFIG } from '../../../../../shared/translations/rewards';

interface PointsConfigSuccessProps {
  breadcrumbs: BreadcrumbItemProps[];
}

const PointsConfigSuccess = ({ breadcrumbs }: PointsConfigSuccessProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const goToHistory = () => {
    tagManagerService.pushEvent(CLICK_ACTION, GO_TO_ORDER_HISTORY);
    navigate(REWARDS_HISTORY_ROUTE);
  };

  const goToCollaboratorsList = () => {
    tagManagerService.pushEvent(CLICK_ACTION, SEND_MORE_POINTS);
    navigate(REWARDS_POINTS_ROUTE);
  };

  return (
    <GenericPageNE
      breadcrumbs={breadcrumbs}
      ImageComponent={JoyBuddy}
      title={{ i18nKey: TRANSLATION_POINTS_CONFIG.success.title, components: { 1: <br /> } }}
      description={t(TRANSLATION_POINTS_CONFIG.success.description)}
      primaryButton={{
        text: t(TRANSLATION_POINTS_CONFIG.success.primaryButton),
        action: goToHistory
      }}
      secondaryButton={{
        text: t(TRANSLATION_POINTS_CONFIG.success.secondaryButton),
        action: goToCollaboratorsList
      }}
    />
  );
};

export default PointsConfigSuccess;
